import { combineReducers } from 'redux';
import { inquiryFormReducer } from './inquiry_form';
export default combineReducers({ inquiryFormReducer });